export enum NavigationItemBadge {
  Warning = 'warning',
  Danger = 'danger',
}
